import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * The About/Unser-Ansatz page is now integrated into the Home page.
 * This redirects any legacy /unser-ansatz visits to /#ansatz.
 */
export default function About() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/#ansatz', { replace: true });
  }, [navigate]);
  return null;
}
